import "./styles/main.css";
import { crispWebsiteId } from "./config";
import { initNavToggle } from "./nav";
import { initLeadForm } from "./lead-form";
import { initSupportChat } from "./support-chat";

// JavaScript on the site is progressive enhancement only — every page renders
// complete, readable HTML with JS disabled (the mobile nav degrades to the
// footer links). The one exception is the pre-registration form: it is a stepped
// wizard, and the Salesforce intake (SF-S015) is a JSON REST endpoint, so
// submitting requires JS. Every step still renders with JS off, and a <noscript>
// block points to email (WWW-S023 / WWW-S035).
initNavToggle(document);

// Pre-register page: refresh dropdown options from Salesforce, drive the step
// machine, apply the abuse guards (honeypot + minimum time before submit,
// WWW-S024), and submit via fetch. No-op on pages without the #lead-form.
//
// The Web-to-Lead reCAPTCHA timestamp helper that used to be called here went
// away with WWW-S024: Web-to-Lead itself is gone (WWW-S023), so the field it
// looked for can no longer exist on any page. Whether a real CAPTCHA challenge
// arrives depends on Aaron's pending edge-proxy decision — AWS WAF's CAPTCHA
// action is only available on a path CloudFront actually serves. See
// docs/lead-intake-protection.md.
initLeadForm(document);

// Crisp live chat (WWW-S051). Every page loads this entry, so importing the
// seam here is what puts the widget on the whole site — no vendor snippet in
// any HTML document, and the vendor host named in exactly one place.
//
// The page is read from `location` at load: this is a real multi-page site, so
// there is no route change to republish the routing key on. Absent
// VITE_CRISP_WEBSITE_ID (the default everywhere until an operator sets it) is
// a complete no-op — nothing is injected and Crisp is never contacted, which
// is why local dev, Vitest and the Playwright smoke need no third party.
initSupportChat(window, window.location.pathname, crispWebsiteId());
